__turbopack_context__.v({
  "product-energy-label": "product-energy-label-component-module-scss-module___wI-fW__product-energy-label",
  "product-energy-label--left-aligned": "product-energy-label-component-module-scss-module___wI-fW__product-energy-label--left-aligned",
  "product-energy-label__datasheet": "product-energy-label-component-module-scss-module___wI-fW__product-energy-label__datasheet",
  "product-energy-label__image": "product-energy-label-component-module-scss-module___wI-fW__product-energy-label__image",
});
